

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import {
    walletTransferDirections,
    walletTransferMethods,
    walletTransferStatuses
} from '../statuses';

export default class WalletTransfersPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'wallet-transfers';
        this.Server = this.props.context.getState().server.walletTransfers;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'direction',
                label: 'direction',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletTransferDirections)
            },
            {
                id: 'method',
                label: 'method',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletTransferMethods)
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletTransferStatuses)
            },
            {
                id: 'instructions',
                label: 'instructions',
                alignRight: false,
                cell: 'Json',
                displayGrid: false,
                disableEditor: true,
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'accountId',
                label: 'account',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletAccounts',
                object: 'account',
                show: 'accountNumber'
            },
            {
                id: 'transferCurrencyId',
                label: 'transferCurrency',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'currencies',
                object: 'currency',
                show: 'name'
            },
            {
                id: 'transferAmount',
                label: 'transferAmount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'accountAmount',
                label: 'accountAmount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'feeAmount',
                label: 'feeAmount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'paymentDate',
                label: 'paymentDate',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

